import { Alert } from "antd";
import { useAtomValue } from "jotai";
import { userAtom } from "../utils/store";

const ProgramInfo = ({ className }: { className?: string }) => {
  const user = useAtomValue(userAtom);
  const fullName = `${user?.firstName} ${user?.lastName}`;
  return (
    <Alert
      type="info"
      message={
        <div>
          <p>
            Applicant: <b>{fullName}</b>
          </p>
          <p>
            Program: {" "}
            <b>
               {user?.programName}
              {/* {user?.programType} {user?.programName} */}
            </b>
          </p>
          <p>
            Area of Specialization: <b>{user?.specialization}</b>
          </p>
          <p>
            Mode of study: <b>{user?.modeOfStudyName}</b>
          </p>
        </div>
      }
      style={{ fontSize: "18px" }}
      className={className}
    />
  );
};

export default ProgramInfo;
